import { useLink } from '../hooks/useLink';

const LinkContainer = () => {
	const { label, blockClass, buttonProps, displayMode, rel } = useLink();

	const getClasses = () => {
		if (displayMode == 'button') {
			let classes = `buttonLink ${blockClass ? `buttonLink--${blockClass} vtex-store-link-0-x-buttonLink--${blockClass}` : ''} vtex-store-link-0-x-buttonLink bw1 fw5 ba v-mid pa0 lh-solid br2 inline-flex items-center no-underline`;
			if (buttonProps?.variant == 'secondary') {
				classes +=
					'bg-action-secondary b--action-secondary c-on-action-secondary hover-bg-action-secondary hover-b--action-secondary hover-c-on-action-secondary';
			} else {
				classes +=
					'bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary';
			}
			if (buttonProps?.size == 'large') classes += ` min-h-large t-action--large`;
			if (buttonProps?.size == 'small') classes += ` min-h-small t-action--small`;
			if (!buttonProps?.size || buttonProps?.size == 'regular') classes += ` min-h-regular t-action`;
			return classes;
		} else {
			return '';
		}
	};

	const getLabelClass = () => {
		if (buttonProps?.size == 'large') return `ph7`;
		if (buttonProps?.size == 'small') return `ph5`;
		if (buttonProps?.size == 'regular') return `ph6`;
	};

	return (
		<a
			href={`#`}
			className={`link ${blockClass ? `vtex-store-link-0-x-link--${blockClass} link--${blockClass}` : ''} vtex-store-link-0-x-link ${getClasses()}`}
			rel={`${rel ? rel : ''} noopener`}
		>
			<span
				className={`label ${blockClass ? `label--${blockClass} vtex-store-link-0-x-label--${blockClass}` : ''} vtex-store-link-0-x-label vt w-100 tc ${getLabelClass()}`}
			>
				{label}
			</span>
		</a>
	);
};

export default LinkContainer;
